import styled from "styled-components";

import { breakpoint } from "@utilities";

export const StyledBanner = styled.div`
    .bannerMobile {
        width: 100vw;
        height: 30vh;
        position: relative;
        overflow: hidden;

        ${breakpoint.breakTablet`
            display: none;
        `}

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .heading {
            position: absolute;
            top: 62%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            text-align: center;
            font-size: 24px;
            font-weight: 300;
            line-height: 32px;
            color: #fff;
            padding: 0 16px;
        }
    }

    .bannerDesktop {
        display: none;
        height: 60vh;
        width: 100vw;
        position: relative;
        overflow: hidden;

        ${breakpoint.breakTablet`
            display: block;
        `}

        img {
            height: 100%;
            width: 100%;
            object-fit: fill;
            object-position: center;
            transform: scale(1);
            max-width: none;
            image-rendering: crisp-edges;
        }

        .heading {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            font-size: 30px;
            font-weight: 300;
            line-height: 40px;
            color: #fff;
            max-width: 869px;

            ${breakpoint.breakIpad`
                font-size: 35px;
                line-height: 50px;
            `}

            ${breakpoint.breakLarge`
                font-size: 45px;
                line-height: 60px;
            `}
        }
    }
`;
